export default __webpack_public_path__ + "static/3-95be51c71135b35195c09a82ab8ecdfa.jpeg";